const toast = require('./toast-message');
require('bootstrap/js/src/modal.js');
const carousel = require('./tab-carousel'); // to apply trust banner init
require('lazyloadxt/dist/jquery.lazyloadxt.extra.min');

function listenForAdd() {
	const addButton = $('#mto-modal .modal-content').find('.add-to-cart-global');
	addButton.off('click');
	addButton.attr('id', 'mto-add');
	addButton.removeClass('add-to-cart-global');
	addButton.click(function() {
		$.spinner().start();
		const pid = $(this).data('pid');
		const addToCartUrl = $(this)
			.siblings('.add-to-cart-url')
			.val();

		const quantity = $(this)
			.closest('.modal-footer')
			.find('.quantity-select')
			.val();

		if (addToCartUrl) {
			$.ajax({
				url: addToCartUrl,
				method: 'POST',
				data: {
					pid: pid,
					quantity: quantity,
				},
				success: function(data) {
					$.spinner().stop();
					$('#mto-modal').modal('hide');
					toast.success(data.message);
					$('.minicart .minicart-quantity').text(data.quantityTotal);
					$('.minicart .minicart-link').attr({
						'aria-label': data.cart.resources.minicartCountOfItems,
						title: data.cart.resources.minicartCountOfItems
					});
				},
				error: function() {
					$.spinner().stop();
					$('#mto-modal').modal('hide');
					$('#mto-modal').on('hidden.bs.modal', function() {
						toast.error('Customisation tool error, please try again.');
					});
				},
			});
		}
	});
}

function listenForVariation() {
	$('.color-attribute').click(function(e) {
		e.preventDefault();
		const url = $(this).data('url');
		updateModal(url);
	});
}

function updateModal(url) {
	$.spinner().start();
	$('#mto-modal').addClass('below-spinner');
	$.ajax({
		url: url,
		type: 'get',
		dataType: 'html',
		success: function(data) {
			$.spinner().stop();
			$('#mto-modal').removeClass('below-spinner');
			const res = JSON.parse(data);
			if (res.renderedTemplate) {
				// Clear old data, in mtoModal.isml
				$('#mto-modal .modal-body').remove();
				$('#mto-modal .modal-footer').remove();
				// Append MTO option info, from quickView.isml
				$('#mto-modal .modal-content').append(res.renderedTemplate);
				listenForAdd();
				listenForVariation();
				$('#mto-modal')
					.on('shown.bs.modal', carousel.trustBannerCarousel)
					.modal('show');
			} else {
				$('#mto-modal').removeClass('below-spinner');
				toast.error('Customisation tool error, please try again.');
				$.spinner().stop();
			}
		},
		error: function(e) {
			$.spinner().stop();
			$('#mto-modal').removeClass('below-spinner');
			toast.error('Customisation tool error, please try again.');
		},
	});
}

module.exports = {
	close: function() {},
	open: function() {
		$('.product-mto-option').click(function(e) {
			const el = $(this);
			$.spinner().start();
			$.ajax({
				url: el.data('url'),
				type: 'get',
				dataType: 'html',
				success: function(data) {
					$.spinner().stop();
					const res = JSON.parse(data);
					if (res.renderedTemplate) {
						// Clear old data, in mtoModal.isml
						$('#mto-modal .modal-body').remove();
						$('#mto-modal .modal-footer').remove();
						// Append MTO option info, from quickView.isml
						$('#mto-modal .modal-content').append(res.renderedTemplate);
						listenForAdd();
						listenForVariation();
						$(window).lazyLoadXT();
						
						$('#mto-modal')
							.on('shown.bs.modal', carousel.trustBannerCarousel)
							.modal('show');
					} else {
						toast.error('Customisation tool error, please try again.');
						$.spinner().stop();
					}
				},
				error: function(e) {
					$.spinner().stop();
					toast.error('Customisation tool error, please try again.');
				},
			});
		});
	},
};
